import { useMutation, useQuery } from 'react-query';
import { network } from 'services/network';

const getExcelExportConfig = (subProgramId) => {
    return network
        .get(`api/bo/getSubProgramPreferenceP6ExcelExport?subProgramId=${subProgramId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const setExcelExportConfig = (params) => {
    return network
        .post('api/bo/setSubProgramPreferenceP6ExcelExport', params)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

export const useQueryGetExcelExportConfig = ({ subProgramId }) => {
    return useQuery<IGetExcelExportConfig, QueryError>(
        ['useQueryGetExcelExportConfig', subProgramId],
        () => getExcelExportConfig(subProgramId),
        {
            enabled: Boolean(subProgramId),
        },
    );
};

export const useMutationSetExcelExportConfig = () => {
    return useMutation<any, QueryError, ISetExcelExportConfig>((params) => setExcelExportConfig(params));
};

interface IGetExcelExportConfig {
    isExtractRemainingDuration: boolean;
    isExtractPercentageComplete: boolean;
    userData: string;
}

interface ISetExcelExportConfig {
    contractId: number;
    isExtractRemainingDuration: boolean;
    isExtractPercentageComplete: boolean;
    userData: string;
}
